import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const hasToBeTrue =
    (): ValidatorFn =>
    (control: AbstractControl): ValidationErrors | null => {
        if (control.value === false) {
            return { hasToBeTrue: true };
        }

        return null;
    };
